import { PropOptions } from "vue";
import { WireEntities } from "@timesheets/common";

export function getComponentRoleProp() {
  return {
    /**
     *
     */
    type: [String, Object],
    required: false,
  } as PropOptions<string | WireEntities.Roles.IRecruitmentAgencyRole>;
}
